import ApiService from './apiService';

export const firehouseApi = {
  getNerisPermissions(params) {
    return ApiService.post(`/neris/permission/adaptive`, params)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
};
